<template>
	<page>
		<module title="满赠活动详情">
			<div v-if="activityInfo">
				<c-detail title="基础信息">
					<c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>
					<c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>
					<c-detail-item label="是否叠加">{{activityInfo.gifts_kinds == 1 ? '叠加' : '不叠加'}}</c-detail-item>
					<c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>
					<c-detail-item label="活动商品" full>
						<c-table v-model="productList" height="auto" border>
							
							<c-table-column
								label="商品信息"
								name="product_name"
								width="200"
							>
								<template v-slot="{data}">
									<div class="flex-center">
										<c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                            {{data.product_name}}
                                        </p>
									</div>
								</template>
							</c-table-column>

							<c-table-column
								label="商品规格"
								name="product_sku_spec"
							></c-table-column>
							
							<c-table-column
								label="价格"
								name="product_price"
								width="80"
							>
								<template v-slot="{data}">￥{{data.product_price}}</template>
							</c-table-column>
							
							<c-table-column
								label="库存"
								name="stock_count"
								width="80"
							></c-table-column>
							
							<c-table-column
								label="满赠条件"
								width="100"
							>
								<template v-slot="{data}">
									满{{data.count}}件可赠
								</template>
							</c-table-column>
							
							<c-table-column
								label="赠品"
							>
								<template v-slot="{data}">
                                    <a class="s-link" @click="showGift(data)">已选赠品({{data.gift_list ? data.gift_list.length : 0}})</a>
								</template>
							</c-table-column>
						</c-table>
					</c-detail-item>
				</c-detail>
			</div>
		</module>
        <c-dialog ref="giftDialog" title="赠品信息" width="800" height="450">
          <c-table ref="typeTable" height="450" :value="gift_product_list">
            <c-table-column
                label="商品信息"
                name="product_name"
                width="200"
            >
              <template v-slot="{data}">
                <div class="flex-center">
                  <c-image :src="data.product_img_url" size="46" preview></c-image>
                    <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                        <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                        {{data.product_name}}
                    </p>
                </div>
              </template>
            </c-table-column>

            <c-table-column
                label="商品规格"
                name="product_sku_spec"
            ></c-table-column>

            <c-table-column
                label="赠送数量"
                name="count"
                width="80"
            ></c-table-column>

            <c-table-column
                label="价格"
                name="product_price"
                width="80"
            >
              <template v-slot="{data}">￥{{data.product_price}}</template>
            </c-table-column>

            <c-table-column
                label="库存"
                name="stock_count"
                width="80"
            ></c-table-column>
          </c-table>
        </c-dialog>
  </page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'reward_gift_detail',
		
		props: {
			id: String
		},
		
		data() {
			return {
				activityInfo: '',
				productList: [],
                gift_product_list: []
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getActivityDetail();
			}
		},
		
		mounted() {
			this.getActivityDetail();
		},
		
		methods: {
			getActivityDetail() {
				this.request({
					url: '/activityGifts/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.activityInfo = data;
						this.productList = data.product_list;
					}
				});
			},
      showGift(data){
        if (data && data.gift_list && data.gift_list.length > 0){
          this.gift_product_list = data.gift_list;
          this.$refs.giftDialog.open();
        }
      }
		}
	}
</script>